import { createStore, compose, applyMiddleware } from "redux";
import { persistStore, persistCombineReducers } from "redux-persist";
import expireReducer from "./transformers/expire";
import createEncryptor from "redux-persist-transform-encrypt";
import reduxThunk from "redux-thunk";

import storage from "redux-persist/es/storage";
import _ from "lodash";

import rootReducers from "./reducers";
import moment from "moment";

const kioskName = _.kebabCase(_.lowerCase(_.deburr(process.env.REACT_APP_KIOSK_NAME)));

const encryptor = createEncryptor({
  secretKey: kioskName,
  onError: function(error) {
    // Handle the error.
  }
});

const expiresUser = expireReducer("security", {
  persistedAtKey: "user.accessUntil",
  expireSeconds: 7 * (60 * 60 * 24),
  expiredState: null, // Reset to empty array after expiry
  onExpired: state => {
    const accounts = _.reject(state.accounts, { id: state.user.id });

    return Object.assign(
      {},
      {
        ...state,
        user: null,
        accounts: accounts
      }
    );
  }
});

const expiresKiosk = expireReducer("app", {
  isExpired: state => {
    if (state.kiosk && state.kiosk.expiresAt) {
      return moment(state.kiosk.expiresAt) < moment();
    }

    return false;
  },
  expiredState: null, // Reset to empty array after expiry
  onExpired: state => {
    return Object.assign(
      {},
      {
        ...state,
        kiosk: null
      }
    );
  }
});
const config = {
  key: kioskName,
  storage,
  transforms: [expiresUser, expiresKiosk, encryptor]
  // debug: true //to get useful logging
};

const reduxMulti = ({ dispatch }) => {
  return next => action =>
    Array.isArray(action) ? action.filter(Boolean).map(dispatch) : next(action);
};

let mainMiddleware = [reduxThunk, reduxMulti];

const configureStore = callback => {
  const reducers = persistCombineReducers(config, rootReducers);
  const enhancers = [applyMiddleware(...mainMiddleware)];
  const persistConfig = {
    enhancers
  };
  const store = createStore(reducers, undefined, compose(...enhancers));
  const persistor = persistStore(store, persistConfig, () => {
    callback && callback(store, persistor);
  });

  return store;
};

export default configureStore;
